import React, { useState } from 'react';
import { Table, TableBody, TableCell, TableRow } from "@mui/material";
import moment from 'moment';
import { SpanMessage } from '../../../helpers/componentHelper';

const PDFKnownDevelopment = ({ knowndata, noDataOfKnownData, kdDataCount, kdTableDataSize, isIndividualDevelopment, isInitialPage }) => {
  const [state, setState] = useState({
    knowndata,
    noDataOfKnownData,
    kdDataCount,
    kdTableDataSize,
    isIndividualDevelopment,
    isInitialPage,
  });

  const NumberFormat = (number) => new Intl.NumberFormat().format(number);

  const chunkArray = (ArrayData, chunkSize) => {
    const tempArray = [];
    for (let index = 0; index < ArrayData.length; index += chunkSize) {
      tempArray.push(ArrayData.slice(index, index + chunkSize));
    }
    return tempArray;
  };

  const headRowsIndex = (headRows) => {
    const sourceurlIndex = headRows.findIndex((row) => row.id === 'sourceurl');
    return sourceurlIndex === -1 ? 0 : sourceurlIndex;
  };

  const calculateVirtualBatchSizeURL = (data) => {
    let rowsHeading = filterRowsHeading(data, true);
    const headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });
    
    let indexForURL = headRowsIndex(headRows);
    let batchUrlSize = calculateBatchSizeURL(indexForURL);
    return batchUrlSize;
  }

  const calculateBatchSizeURL = (indexurl) => {
    const { isIndividualDevelopment, isInitialPage } = state;
    let batchUrlSize = isIndividualDevelopment ? 5 : isInitialPage ? 1 : 5;
    return batchUrlSize + (28 - indexurl);
  };

  const filterRowsHeading = (data, forPage1) => {
    let rowsHeading = [];
    if(forPage1)
    rowsHeading = [
      data.filter(x => x.stage !== '' && x.stage !== null).length > 0 ? { id: 'stage', numeric: false, disablePadding: true, label: 'Stage' } : {},
      data.filter(x => x.projecttype !== '' && x.projecttype !== null).length > 0 ? { id: 'projecttype', numeric: false, disablePadding: true, label: 'Project Type' } : {},
      data.filter(x => x.facilityname !== '' && x.facilityname !== null).length > 0 ? { id: 'facilityname', numeric: false, disablePadding: true, label: 'Facility Name' } : {},
      data.filter(x => x.address !== '' && x.address !== null).length > 0 ? { id: 'address', numeric: false, disablePadding: true, label: 'Address' } : {},
      data.filter(x => x.county !== '' && x.county !== null).length > 0 ? { id: 'county', numeric: false, disablePadding: true, label: 'County' } : {},
      data.filter(x => x.facilitytype !== '' && x.facilitytype !== null).length > 0 ? { id: 'facilitytype', numeric: false, disablePadding: true, label: 'Facility Type' } : {},
      data.filter(x => x.propertyurl !== '' && x.propertyurl !== null).length > 0 ? { id: 'propertyurl', numeric: false, disablePadding: true, label: 'PropertyUrl' } : {},
      data.filter(x => x.zoning !== '' && x.zoning !== null).length > 0 ? { id: 'zoning', numeric: false, disablePadding: true, label: 'Zoning' } : {},
      data.filter(x => x.summary !== '' && x.summary !== null).length > 0 ? { id: 'summary', numeric: false, disablePadding: true, label: 'Development Project Summary' } : {},
      data.filter(x => x.acres !== '' && x.acres !== null).length > 0 ? { id: 'acres', numeric: true, disablePadding: true, label: 'Acres' } : {},
      data.filter(x => x.propertybuildingpermit !== '' && x.propertybuildingpermit !== null).length > 0 ? { id: 'propertybuildingpermit', numeric: true, disablePadding: true, label: 'Property Building Permit' } : {},
      data.filter(x => x.propertybuildingparcel !== '' && x.propertybuildingparcel !== null).length > 0 ? { id: 'propertybuildingparcel', numeric: true, disablePadding: true, label: 'Property Building Parcel' } : {},
      data.filter(x => x.noofbuildings !== '' && x.noofbuildings !== null).length > 0 ? { id: 'noofbuildings', numeric: true, disablePadding: true, label: 'Number of Buildings' } : {},
      data.filter(x => x.estimatevalue !== '' && x.estimatevalue !== null).length > 0 ? { id: 'estimatevalue', numeric: true, disablePadding: true, label: 'Estimated Value' } : {},
      data.filter(x => x.permithistorylog !== '' && x.permithistorylog !== null).length > 0 ? { id: 'permithistorylog', numeric: true, disablePadding: true, label: 'Permit History Log' } : {},
      data.filter(x => x.permitmonth !== '' && x.permitmonth !== null).length > 0 ? { id: 'permitmonth', numeric: true, disablePadding: true, label: 'Permit Month' } : {},
      data.filter(x => x.salesstatus !== '' && x.salesstatus !== null).length > 0 ? { id: 'salesstatus', numeric: true, disablePadding: true, label: 'Sales Status' } : {},
      data.filter(x => x.salespricing !== '' && x.salespricing !== null).length > 0 ? { id: 'salespricing', numeric: true, disablePadding: true, label: 'Sales Pricing' } : {},
      data.filter(x => x.expectedopendate !== '' && x.expectedopendate !== null).length > 0 ? { id: 'expectedopendate', numeric: false, disablePadding: true, label: 'Expected Open Date' } : {},
      data.filter(x => x.verifiedstatus !== '' && x.verifiedstatus !== null).length > 0 ? { id: 'verifiedstatus', numeric: true, disablePadding: true, label: 'Project Verification Status' } : {},
      data.filter(x => x.sourceurl !== '' && x.sourceurl !== null).length > 0 ? { id: 'sourceurl', numeric: false, disablePadding: true, label: 'Source URL' } : {},
      data.filter(x => x.citycountyofficephone !== '' && x.citycountyofficephone !== null).length > 0 ? { id: 'citycountyofficephone', numeric: true, disablePadding: true, label: 'City/County Office Phone' } : {},
      data.filter(x => x.citycountytollfree !== '' && x.citycountytollfree !== null).length > 0 ? { id: 'citycountytollfree', numeric: true, disablePadding: true, label: 'City/County TollFree' } : {},
      // { id: 'notes', numeric: false, disablePadding: true, label: 'Notes' },
      data.filter(x => x.lastcheckeddate !== '' && x.lastcheckeddate !== null).length > 0 ? { id: 'lastcheckeddate', numeric: false, disablePadding: true, label: 'Last Checked Date' } : {},
    ];
    else
    rowsHeading = [      
      data.filter(x => x.sourceurl !== '' && x.sourceurl !== null).length > 0 ? { id: 'sourceurl', numeric: false, disablePadding: true, label: 'Source URL' } : {},
      data.filter(x => x.citycountyofficephone !== '' && x.citycountyofficephone !== null).length > 0 ? { id: 'citycountyofficephone', numeric: true, disablePadding: true, label: 'City/County Office Phone' } : {},
      data.filter(x => x.citycountytollfree !== '' && x.citycountytollfree !== null).length > 0 ? { id: 'citycountytollfree', numeric: true, disablePadding: true, label: 'City/County TollFree' } : {},
      // { id: 'notes', numeric: false, disablePadding: true, label: 'Notes' },
      data.filter(x => x.lastcheckeddate !== '' && x.lastcheckeddate !== null).length > 0 ? { id: 'lastcheckeddate', numeric: false, disablePadding: true, label: 'Last Checked Date' } : {},
    ];
    return rowsHeading;
  }
  const getSourceUrlList = (sourceURLS) => {
    return sourceURLS
      ? sourceURLS
          .toString()
          .replace(/&amp;/gi, "&")
          .split("; ")
          .map((s) => s.trim())
          .filter(Boolean)
      : [];
  };
  const getRestData = (data) => {
    var _Table_Cell_Vals = [];
    var Data_Rows_Element = [];    
    let rowsHeading = filterRowsHeading(data, true);
    let headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });
    let indexForURL = headRowsIndex(headRows);
    let batchUrlSize = calculateBatchSizeURL(indexForURL);
    
    rowsHeading = filterRowsHeading(data, false);
    headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });
    for (let col = 0; col < headRows.length; col++) {  //stage
      for (let item = 0; item < data.length; item++) {  //data1
        const _recordDate = data[item];
        const colName = headRows[col];        
        if (colName.id === 'lastcheckeddate') {
          _recordDate.lastcheckeddate = _recordDate && _recordDate !== null && _recordDate.lastcheckeddate ? moment(_recordDate.lastcheckeddate).format('DD-MMM-YYYY') : '-';
        }        
        if (item === 0) {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-heading" align="center" key={Math.random()} >{colName.label}</TableCell>
          );
        }
        
        var sourceURLS = '';
        if (colName.id === 'sourceurl') {
          const allSourceURLs = getSourceUrlList(_recordDate.sourceurl)          
          const firstPageURLs = allSourceURLs.slice(0, batchUrlSize);          
          const nextPageURLs = allSourceURLs.slice(batchUrlSize)
        
          sourceURLS = nextPageURLs.length ? nextPageURLs.map((data, urlCount , arr) => {
            urlCount = urlCount + batchUrlSize+1
            try {
              let domain = new URL(data);
              const pathSegments = domain.pathname.split('/').filter(Boolean); // Split path into segments
              const lastSegment = pathSegments[pathSegments.length - 1]; // Get the last segment of the path
        
              return (
                <div className="source-url cont" lang="de" key={urlCount}>
                  <a target="_blank" href={data} title={data} className="source-url">
                    Source URL {arr.length === 1 ? "" : urlCount}
                   
                  </a>
                  ({domain.origin}/.....{lastSegment})
                </div>
              );
            } catch (error) {
              return <span key={urlCount}>Invalid URL</span>;
            }
          }) : '-';
        }
        if (colName.id === "sourceurl") {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{sourceURLS}</TableCell>
          );
        } else {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{_recordDate[colName.id] ? _recordDate[colName.id] : '-'}</TableCell>
          );
        }
      }
    }

    const Datas = chunkArray(_Table_Cell_Vals, data.length + 1);
    Datas.map((rows) => {
      return Data_Rows_Element.push(<TableRow key={Math.random()}>{rows}</TableRow>)
    })
    var _elementBody;
    if (Data_Rows_Element.length === 0) {
      _elementBody = <div>
        <p className="known-dev-nodata color-important text-center m-0 p-2" style={{ fontSize: '12px' }}>No Data Found</p>
      </div>
    } else {
      _elementBody = <TableBody key={Math.random()}>
        {Data_Rows_Element}
      </TableBody>
    }
    var _result = [_elementBody]
    return _result
  }

  const getData = (data) => {    
    let removedRow = 1;
    var _Table_Cell_Vals = [];
    var Data_Rows_Element = [];    
    let rowsHeading = filterRowsHeading(data, true);
    const headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });
    
    let indexForURL = headRowsIndex(headRows);
    let batchUrlSize = calculateBatchSizeURL(indexForURL);
    
    let allURLlength = false;  
    for (let col = 0; col < headRows.length; col++) {  //stage
      for (let item = 0; item < data.length; item++) {  //data1
        const _recordDate = data[item];
        const colName = headRows[col];
        if (colName.id === 'propertyurl') {
          _recordDate.propertyurl = _recordDate.propertyurl && typeof _recordDate.propertyurl != 'object' && _recordDate.propertyurl != '-'
            ? _recordDate.propertyurl
              .toString()
              .replace(/&amp;/gi, "&")
              .split("; ")
              .map((data) => {

                if (!/^https?:\/\//i.test(data)) {
                  data = 'http://' + data; // Add 'http://' if missing
                }
              
                let domain;
                try {
                  domain = new URL(data);
                } catch (e) {
                  return (
                    <span className="invalid-url">Invalid URL: {data}</span>
                  );
                }
              
                const segment_array = data;
                const last_segment = segment_array.slice(segment_array.length - 15);
                
                return (
                  <>
                    <a target="_blank" href={data} title={data} className="source-url">
                      {domain.origin}/.....{last_segment}
                    </a>
                  </>
                );
              })
            : "-";
          }

        if(colName.id == "citycountyofficephone" || colName.id == "citycountytollfree"){
          removedRow++;
        }
        if (colName.id === 'lastcheckeddate') {
          _recordDate.lastcheckeddate = _recordDate && _recordDate !== null && _recordDate.lastcheckeddate ? moment(_recordDate.lastcheckeddate).format('DD-MMM-YYYY') : '-';
        }
        if (colName.id === 'expectedopendate') {
          _recordDate.expectedopendate = _recordDate.expectedopendate === null || _recordDate.expectedopendate === '' ? '-' : moment(_recordDate.expectedopendate).format('DD-MMM-YYYY');
        }
        if (item === 0) {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-heading" align="center" key={Math.random()} >{colName.label}</TableCell>
          );
        }
        var sourceURLS = '';
        if (colName.id === 'sourceurl') {
          const allSourceURLs = getSourceUrlList(_recordDate.sourceurl)

            if(allSourceURLs.length > batchUrlSize){
              allURLlength = true
            }
          const firstPageURLs = allSourceURLs.slice(0, batchUrlSize); 
          const nextPageURLs = allSourceURLs.slice(batchUrlSize);
          sourceURLS = firstPageURLs.length ? firstPageURLs.map((data, urlCount, totLength) => {           
            let domain;
            try {
              domain = new URL(data);
            } catch {
              return <span className="invalid-url">Invalid URL: {data}</span>;
            }
                const segment_array = data;
                const last_segment = segment_array.slice(segment_array.length - 15);
                return (
                  <>
                    <div className='source-url cont' lang='de'>
                      <a target="_blank" href={data} title={data} className="source-url">
                        Source URL {totLength.length === 1 ? "" : (urlCount + 1)}
                      </a>
                      ({domain.origin}/.....{last_segment})
                    </div>
                  </>
                );
              })
            : "-";
        }
        if (colName.id === "sourceurl") {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{sourceURLS}</TableCell>
          );
        } else {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{_recordDate[colName.id] ? _recordDate[colName.id] : '-'}</TableCell>
          );
        }
      }
    }
    const Datas = chunkArray(_Table_Cell_Vals, data.length + 1);
    Datas.map((rows) => {
      return Data_Rows_Element.push(<TableRow key={Math.random()}>{rows}</TableRow>)
    })
    var _elementBody;
    if (Data_Rows_Element.length === 0) {
      _elementBody = <div>
        <p className="known-dev-nodata color-important text-center m-0 p-2" style={{ fontSize: '12px' }}>No Data Found</p>
      </div>
    } else {
      _elementBody = <TableBody key={Math.random()}>
        {allURLlength ? Data_Rows_Element.slice(0, Data_Rows_Element.length-removedRow) : Data_Rows_Element}
      </TableBody>
    }
    var _result = [_elementBody]
    return _result
  }

  const getOwnerData = (data) => {
    var _Table_Cell_Vals = [];
    var Data_Rows_Element = [];
    const rowsHeading = [
      data.filter(x => x.ownername !== '' && x.ownername !== null).length > 0 ? { id: 'ownername', numeric: false, disablePadding: true, label: 'Owner Name' } : {},
      data.filter(x => x.owneraddress !== '' && x.owneraddress !== null).length > 0 ? { id: 'owneraddress', numeric: false, disablePadding: true, label: 'Owner Address' } : {},
      data.filter(x => x.ownerphone !== '' && x.ownerphone !== null).length > 0 ? { id: 'ownerphone', numeric: false, disablePadding: true, label: 'Owner Phone' } : {},
      data.filter(x => x.ownercontactname !== '' && x.ownercontactname !== null).length > 0 ? { id: 'ownercontactname', numeric: false, disablePadding: true, label: 'Owner Contact Name' } : {},
      data.filter(x => x.owneremail !== '' && x.owneremail !== null).length > 0 ? { id: 'owneremail', numeric: false, disablePadding: true, label: 'Owner Email' } : {},
      data.filter(x => x.companyname !== '' && x.companyname !== null).length > 0 ? { id: 'companyname', numeric: false, disablePadding: true, label: 'Operator/Management' } : {},
    ];
    const headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });

    for (let col = 0; col < headRows.length; col++) {  //stage
      for (let item = 0; item < data.length; item++) {  //data1
        const _recordDate = data[item];
        const colName = headRows[col];
        if (item === 0) {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-heading" align="center" key={Math.random()} >{colName.label}</TableCell>
          );
        }
        _Table_Cell_Vals.push(
          <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{_recordDate[colName.id] ? _recordDate[colName.id] : '-'}</TableCell>
        );
      }
    }
    const Datas = chunkArray(_Table_Cell_Vals, data.length + 1);
    Datas.map((rows) => {
      return Data_Rows_Element.push(<TableRow key={Math.random()}>{rows}</TableRow>)
    })
    var _elementBody;
    if (Data_Rows_Element.length === 0) {
      _elementBody = <div>
        <p className="known-dev-nodata color-important text-center m-0 p-2" style={{ fontSize: '12px' }}>No Data Found</p>
      </div>
    } else {
      _elementBody = <TableBody key={Math.random()}>
        {Data_Rows_Element}
      </TableBody>
    }
    var _result = [_elementBody]
    return _result
  }

  const getContractorData = (data) => {
    var _Table_Cell_Vals = [];
    var Data_Rows_Element = [];
    const rowsHeading = [
      data.filter(x => x.contractorname !== '' && x.contractorname !== null).length > 0 ? { id: 'contractorname', numeric: false, disablePadding: true, label: 'Contractor Name' } : {},
      data.filter(x => x.contractoraddress !== '' && x.contractoraddress !== null).length > 0 ? { id: 'contractoraddress', numeric: false, disablePadding: true, label: 'Contractor Address' } : {},
      data.filter(x => x.contractorphone !== '' && x.contractorphone !== null).length > 0 ? { id: 'contractorphone', numeric: false, disablePadding: true, label: 'Contractor Phone' } : {},
      data.filter(x => x.contractorcontactname !== '' && x.contractorcontactname !== null).length > 0 ? { id: 'contractorcontactname', numeric: false, disablePadding: true, label: 'Contractor Contact Name' } : {},
      data.filter(x => x.contractoremail !== '' && x.contractoremail !== null).length > 0 ? { id: 'contractoremail', numeric: false, disablePadding: true, label: 'Contractor Email' } : {}
    ];
    const headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });
    for (let col = 0; col < headRows.length; col++) {  //stage
      for (let item = 0; item < data.length; item++) {  //data1
        const _recordDate = data[item];
        const colName = headRows[col];
        if (item === 0) {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-heading" align="center" key={Math.random()} >{colName.label}</TableCell>
          );
        }
        _Table_Cell_Vals.push(
          <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{_recordDate[colName.id] ? _recordDate[colName.id] : '-'}</TableCell>
        );
      }
    }
    const Datas = chunkArray(_Table_Cell_Vals, data.length + 1);
    Datas.map((rows) => {
      return Data_Rows_Element.push(<TableRow key={Math.random()}>{rows}</TableRow>)
    })
    var _elementBody;
    if (Data_Rows_Element.length === 0) {
      _elementBody = <div>
        <p className="known-dev-nodata color-important text-center m-0 p-2" style={{ fontSize: '12px' }}>No Data Found</p>
      </div>
    } else {
      _elementBody = <TableBody key={Math.random()}>
        {Data_Rows_Element}
      </TableBody>
    }
    var _result = [_elementBody]
    return _result
  }

  const getOperatorMgtData = (data) => {
    var _Table_Cell_Vals = [];
    var Data_Rows_Element = [];
    const rowsHeading = [
      data.filter(x => x.companyname !== '' && x.companyname !== null).length > 0 ? { id: 'companyname', numeric: false, disablePadding: true, label: 'Operator/Management Company Name' } : {},
      data.filter(x => x.operatortype !== '' && x.operatortype !== null).length > 0 ? { id: 'operatortype', numeric: false, disablePadding: true, label: 'Operator Type' } : {}
    ];
    const headRows = rowsHeading.filter(element => {
      if (Object.keys(element).length !== 0) {
        return true;
      }
      return false;
    });

    for (let col = 0; col < headRows.length; col++) {  //stage
      for (let item = 0; item < data.length; item++) {  //data1
        const _recordDate = data[item];
        const colName = headRows[col];
        if (item === 0) {
          _Table_Cell_Vals.push(
            <TableCell style={{ color: '#000 !important' }} className="table-row-heading" align="center" key={Math.random()} >{colName.label}</TableCell>
          );
        }
        _Table_Cell_Vals.push(
          <TableCell style={{ color: '#000 !important' }} className="table-row-items" align="center" key={Math.random()} >{_recordDate[colName.id] ? _recordDate[colName.id] : '-'}</TableCell>
        );
      }
    }
    const Datas = chunkArray(_Table_Cell_Vals, data.length + 1);
    Datas.map((rows) => {
      return Data_Rows_Element.push(<TableRow key={Math.random()}>{rows}</TableRow>)
    })
    var _elementBody;
    if (Data_Rows_Element.length === 0) {
      _elementBody = <div>
        <p className="known-dev-nodata color-important text-center m-0 p-2" style={{ fontSize: '12px' }}>No Data Found</p>
      </div>
    } else {
      _elementBody = <TableBody key={Math.random()}>
        {Data_Rows_Element}
      </TableBody>
    }
    var _result = [_elementBody]
    return _result
  }

  return (
    <div className="pdf-widget-knownDev mt-2">
        <div className="table-responsive" style={{ height: '100%' }}>
          {knowndata && knowndata.length > 0 ?
            <React.Fragment>
              {(kdTableDataSize === "large" || ((kdTableDataSize === "medium" || kdTableDataSize === "small") && kdDataCount === 1)) && <>
                <h5 className="kd-sub-title">Development Property Info</h5>
                <Table className="flat-table known_dev_table" aria-label="simple table" key={Math.random()}>
                  {getData(knowndata)}
                </Table>
              </>}
              {(kdTableDataSize === "large" || (kdTableDataSize === "medium" && kdDataCount === 1) || (kdTableDataSize === "small" && kdDataCount === 2)) && <>
                {(knowndata.some(data => 
                  data.sourceurl && 
                  data.sourceurl.split("; ").filter(url => url.trim() !== "").length > calculateVirtualBatchSizeURL(knowndata)
                ) && (
                  <>
                    <h5 className="kd-sub-title">Development Property Info</h5>
                    <Table className="flat-table known_dev_table" aria-label="simple table" key={Math.random()}>
                      {getRestData(knowndata)}
                    </Table>
                  </>
                )) } 
                <h5 className="mt-2 kd-sub-title">Ownership Info</h5>
                <Table className="flat-table known_dev_table" aria-label="simple table" key={Math.random()}>
                  {getOwnerData(knowndata)}
                </Table>
              </>}
              {(kdTableDataSize === "large" || ((kdTableDataSize === "medium" || kdTableDataSize === "small") && kdDataCount === 2)) && <>
                <h5 className="mt-2 kd-sub-title">Contractor Info</h5>
                <Table className="flat-table known_dev_table" aria-label="simple table" key={Math.random()}>
                  {getContractorData(knowndata)}
                </Table>
              </>}
              {(kdTableDataSize === "large" || ((kdTableDataSize === "medium" || kdTableDataSize === "small") && kdDataCount === 2)) && <>
                <h5 className="mt-2 kd-sub-title">Operator/Management Info</h5>
                <Table className="flat-table known_dev_table" aria-label="simple table" key={Math.random()}>
                  {getOperatorMgtData(knowndata)}
                </Table>
              </>}
            </React.Fragment>
            : SpanMessage("developments") }
        </div>
      </div>
  );
};

export default PDFKnownDevelopment;